import type { FC, ReactNode } from 'react'

import { Plus } from 'lucide-react'
import SectionHeading from '@/components/landing/section-heading'
import { FAQS } from '@/constants/landing'

const FaqSection: FC = (): ReactNode => {
    return (
        <section id='faq' aria-labelledby='faq-title' className='relative scroll-mt-20 py-24 sm:py-32'>
            <div className='mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16'>
                <SectionHeading
                    id='faq-title'
                    eyebrow='FAQ'
                    accent='violet'
                    title='Questions before your first move?'
                    description="The short answers to what players ask us most. Anything else, ask us once you're in."
                />

                <div className='divide-y divide-white/10 border-y border-white/10'>
                    {FAQS.map(item => (
                        <details key={item.question} className='group py-1'>
                            <summary className='flex cursor-pointer list-none items-center justify-between gap-6 rounded-xl py-5 text-left font-heading text-base font-semibold tracking-tight transition-colors hover:text-neon-cyan focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon-cyan sm:text-lg [&::-webkit-details-marker]:hidden'>
                                {item.question}

                                <span className='flex size-8 shrink-0 items-center justify-center rounded-full border border-white/15 text-muted-foreground transition-all duration-300 group-open:rotate-45 group-open:border-neon-cyan/60 group-open:text-neon-cyan'>
                                    <Plus className='size-4' />
                                </span>
                            </summary>

                            <p className='pb-6 pr-12 text-base leading-relaxed text-muted-foreground'>
                                {item.answer}
                            </p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FaqSection
